export const initialProjects = [
  {
    id: "proj-1",
    slug: "medflow-telehealth-platform",
    name: "MedFlow Telehealth Suite",
    client: "MedFlow Global Health",
    category: "Healthcare",
    serviceCategory: "Web",
    industry: "Healthcare",
    image: "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?auto=format&fit=crop&w=600&q=75",
    shortDescription: "HIPAA-compliant telemedicine and remote consultation platform serving 250,000+ patients across North America.",
    technologies: ["React", "TypeScript", "Node.js", "WebRTC", "PostgreSQL", "AWS"],
    featured: true,
    results: "99.98% video uptime, 40% reduction in patient wait times",
    liveUrl: "https://medflow-demo.buildzone.tech",
    caseStudySlug: "medflow-telehealth-platform"
  },
  {
    id: "proj-2",
    slug: "omnistock-ai-supply-chain",
    name: "OmniStock AI Inventory Engine",
    client: "OmniStock Logistics",
    category: "AI",
    serviceCategory: "AI",
    industry: "Logistics",
    image: "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?auto=format&fit=crop&w=600&q=75",
    shortDescription: "Autonomous inventory forecasting & supply chain optimization platform with predictive machine learning models.",
    technologies: ["Python", "FastAPI", "React", "Pinecone", "Docker", "TimescaleDB"],
    featured: true,
    results: "34% reduction in stockouts, $1.2M in annual inventory savings",
    liveUrl: "https://omnistock-demo.buildzone.tech",
    caseStudySlug: "omnistock-ai-supply-chain"
  },
  {
    id: "proj-3",
    slug: "finvault-banking-portal",
    name: "FinVault Corporate Banking",
    client: "FinVault Financial",
    category: "FinTech",
    serviceCategory: "SaaS",
    industry: "FinTech",
    image: "https://images.unsplash.com/photo-1559526324-4b87b5e36e44?auto=format&fit=crop&w=600&q=75",
    shortDescription: "Next-generation corporate treasury and multi-currency payout platform processing over $120M in monthly volume.",
    technologies: ["Next.js", "Tailwind CSS", "Node.js", "PostgreSQL", "Kafka", "AWS"],
    featured: true,
    results: "$120M+ monthly transaction volume processed with sub-100ms latency",
    liveUrl: "https://finvault-demo.buildzone.tech",
    caseStudySlug: "finvault-banking-portal"
  },
  {
    id: "proj-4",
    slug: "pulsefit-mobile-ecosystem",
    name: "PulseFit Connected Training",
    client: "PulseFit Technologies",
    category: "Sports & Fitness",
    serviceCategory: "Mobile",
    industry: "Sports & Fitness",
    image: "https://images.unsplash.com/photo-1534438327276-14e5300c3a48?auto=format&fit=crop&w=600&q=75",
    shortDescription: "Cross-platform mobile training app with live wearable heart-rate telemetry, video coaching, and AI workout planners.",
    technologies: ["React Native", "Swift", "Node.js", "GraphQL", "Firebase"],
    featured: true,
    results: "500K+ app downloads, 4.9 App Store rating across 15,000 reviews",
    liveUrl: "https://pulsefit-demo.buildzone.tech",
    caseStudySlug: "pulsefit-mobile-ecosystem"
  },
  {
    id: "proj-5",
    slug: "aerovista-travel-aggregator",
    name: "AeroVista Luxury Jet Booking",
    client: "AeroVista Global Aviation",
    category: "Travel",
    serviceCategory: "E-Commerce",
    industry: "Travel",
    image: "https://images.unsplash.com/photo-1540959733332-eab4deabeeaf?auto=format&fit=crop&w=600&q=75",
    shortDescription: "Real-time private aircraft charter marketplace with instant empty-leg search and escrow checkout.",
    technologies: ["Next.js", "TypeScript", "Python", "Redis", "Stripe Connect"],
    featured: false,
    results: "Instant flight charter booking in under 3 minutes",
    liveUrl: "https://aerovista-demo.buildzone.tech",
    caseStudySlug: "aerovista-travel-aggregator"
  },
  {
    id: "proj-6",
    slug: "cloudscale-kubernetes-dashboard",
    name: "CloudScale DevSecOps Console",
    client: "CloudScale Systems",
    category: "Cloud",
    serviceCategory: "UI/UX",
    industry: "SaaS",
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=600&q=75",
    shortDescription: "Unified multi-cloud monitoring dashboard consolidating Kubernetes cluster telemetry, logs, and security alerts.",
    technologies: ["React", "Tailwind CSS", "Go", "Prometheus", "Docker"],
    featured: false,
    results: "80% reduction in mean-time-to-detection (MTTD) for outages",
    liveUrl: "https://cloudscale-demo.buildzone.tech",
    caseStudySlug: "cloudscale-kubernetes-dashboard"
  }
];
